import { isImage, isVideo, isDocument } from 'utilities/file';

class MeetingInterfaces {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/meetings`;
    this.apiClient = apiClient;

  }

  async createMeetingForUser(meeting) {

    const path = `${this.basePath}`;

    return this.apiClient.post(path, {}, {}, meeting);

  }

  async createFileForNewMeeting(file) {

    let path = `${this.basePath}`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.post(path, {}, {}, data, true, false);

  }

  async updateMeetingFacade(meetingId, data) {

    const path = `${this.basePath}/:meetingId`;

    return this.apiClient.put(path, { meetingId }, {}, data);

  }

  async createFileForExistingMeeting(meetingId, file) {

    let path = `${this.basePath}/:meetingId`;

    if (isImage(file)) {
      path = `${path}/images`;
    } else if (isVideo(file)) {
      path = `${path}/videos`;
    } else if (isDocument(file)) {
      path = `${path}/documents`;
    }

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, { meetingId }, {}, data, true, false);

  }

  async updateReminders(meetingId, data) {

    const path = `${this.basePath}/:meetingId/reminders`;

    return this.apiClient.post(path, { meetingId }, {}, data);

  }

  async attendMeeting(meetingId) {

    const path = `${this.basePath}/:meetingId/attend`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async mayAttendMeeting(meetingId) {

    const path = `${this.basePath}/:meetingId/may-be`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async declineMeeting(meetingId) {

    const path = `${this.basePath}/:meetingId/decline`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async attendAllUpcomingMeetings(meetingId) {

    const path = `${this.basePath}/:meetingId/attend-all`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async mayAttendAllUpcomingMeetings(meetingId) {

    const path = `${this.basePath}/:meetingId/may-be-all`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async declineAllUpcomingMeetings(meetingId) {

    const path = `${this.basePath}/:meetingId/decline-all`;

    return this.apiClient.put(path, { meetingId }, {}, {});

  }

  async uninviteAttendee(meetingId) {

    const path = `${this.basePath}/:meetingId/uninvite`;

    return this.apiClient.delete(path, { meetingId }, {});

  }

  async uninviteAttendeeFromUpcomingMeetings(meetingId) {

    const path = `${this.basePath}/:meetingId/uninvite-upcoming`;

    return this.apiClient.delete(path, { meetingId }, {});

  }

  async cancelAppointmentByMeetingId(meetingId) {

    const path = `${this.basePath}/:meetingId/appointment`;

    return this.apiClient.delete(path, { meetingId }, {});

  }

  async deleteMeetingById(meetingId) {

    const path = `${this.basePath}/:meetingId`;

    return this.apiClient.delete(path, { meetingId }, {});

  }

  async deleteUpcomingMeetingsById(meetingId) {

    const path = `${this.basePath}/:meetingId/upcoming`;

    return this.apiClient.delete(path, { meetingId }, {});

  }

}

export default MeetingInterfaces;